import DistributorLayout from '@/layouts/DistributorLayout.vue'

export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/restricted/profile/ProfileDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      menuSelected: 'profile'
    }
  },
  {
    path: '/profile/collaborators/create',
    name: 'profileCollaboratorCreate',
    component: () => import('@/views/restricted/profile/ProfileCollaboratorCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_COLLABORATOR'],
      menuSelected: 'profile'
    }
  },
  {
    path: '/profile/collaborators/:collaboratorId/edit',
    name: 'profileCollaborator',
    component: () => import('@/views/restricted/profile/ProfileCollaboratorView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_UPDATE_COLLABORATOR'],
      menuSelected: 'profile'
    }
  },
  {
    path: '/profile/create-collaborator/new',
    redirect: (to) => ({ name: 'profileCollaboratorCreate', query: to.query, hash: to.hash })
  },
  {
    path: '/profile/edit-collaborator/:collaboratorId',
    redirect: (to) => ({
      name: 'profileCollaborator',
      params: { collaboratorId: to.params.collaboratorId },
      query: to.query,
      hash: to.hash
    })
  }
]
